import { OverlappingMarkerSpiderfier } from "../common/oms.min.js";
import { MarkerClusterer } from "@googlemaps/markerclusterer"
import { MarkerWithLabel } from "@googlemaps/markerwithlabel"
import Supercluster from "supercluster"
import general from "./general";
import complexes from "./complexes";
import { debounce } from "./helpers";

const map = {

    map: null,
    config: null,

    init: function () {
        document.addEventListener('DOMContentLoaded', () => {
            this.handleMapInit()
            this.handleMarkerClusterer()

            general.mainMenuShow();
        })

        $(document).on('map-cards-slider-init', () => {
            complexes.cardsSliderInit()
        })

        jQuery.fn.scrollTo = function(elem, speed, callback) {
            // с анимацией
            $(this).animate({
                scrollTop:  $(this).scrollTop() - $(this).offset().top + $(elem).offset().top - 300
            },
            // без анимации
            // $(this).scrollTop($(this).scrollTop() - $(this).offset().top + $(elem).offset().top - 300);
            speed == undefined ? 1000 : speed,
            callback == undefined ? () => {} : callback
            );
            return this;
        };
    },

    /**
     * Инциализация карты
     *
     * @return void
     */
    handleMapInit: function () {
        const mapSettings = $('[data-map-settings]').data('map-settings')
        mapSettings['config']['style'] = JSON.parse(mapSettings['config']['style'])

        this.config = mapSettings['config']
        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: this.config['zoom'],
            center: this.config['center'],
            disableDefaultUI: this.config['disableDefaultUI'],
            gestureHandling: this.config['gestureHandling'],
            keyboardShortcuts: this.config['keyboardShortcuts'],
            styles: this.config['style']
        });

        google.maps.event.addListener(this.map, 'click', function(event){
            $(document).trigger('map-click')
        });
    },

    /**
     * Обработчик кластеризации маркеров
     *
     * @return void
     */
    handleMarkerClusterer: function () {
        const map = this.map;
        const mti = google.maps.MapTypeId;
        const markers = this.getMarkers($('[data-map-items]').data('map-items'))
        const maxZoom = this.config['zoom']
        const icon = '<svg class="map-icon cluster" width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8.484" width="12" height="12" rx="1" transform="rotate(45 8.484 0)" fill="#BF9E77"/></svg>';

        // Сабкластеризация, если маркеры расположены близко друг к другу, или на одной координате
        const oms = new OverlappingMarkerSpiderfier(map, {
            markersWontMove: true,    // we promise not to move any markers, allowing optimizations
            markersWontHide: true,    // we promise not to change visibility of any markers, allowing optimizations
            basicFormatEvents: true,  // allow the library to skip calculating advanced formatting information
            keepSpiderfied: true,
            ignoreMapClick: true,
            legColors: {
                'usual': {
                    [mti.HYBRID]: '#fff',
                    [mti.SATELLITE]: '#fff',
                    [mti.TERRAIN]: '#444',
                    [mti.ROADMAP]: '#444',
                },
                'highlighted': {
                    [mti.HYBRID]: '#444',
                    [mti.SATELLITE]: '#444',
                    [mti.TERRAIN]: '#444',
                    [mti.ROADMAP]: '#444',
                },
            }
        })

        oms.addListener('spiderfy', (markers) => {
            markers.map((marker) => {
                $(marker.label.labelDiv).addClass('map__marker-label--hidden')
            })
        })

        oms.addListener('unspiderfy', (markers) => {
            markers.map((marker) => {
                $(marker.label.labelDiv).removeClass('map__marker-label--hidden')
            })
        })

        markers.map((marker) => {
            oms.addMarker(marker)
        })

        // Кластеризация маркеров, алгоритм позволяет кластеризовать более 9 миллионов маркеров, но также можно его настроить
        const markerClusterer = new MarkerClusterer({
            markers,
            map,
            clusterClass: 'custom-clustericon',
            onClusterClick: debounce((event, cluster, map) => {
                map.setCenter(cluster.marker.getPosition())

                if (map.getZoom() <= maxZoom) {
                    map.setZoom(maxZoom + 1)
                }

                $(document).trigger('map-cluster-click', {
                    markers: cluster.markers
                })
            }, 400),
            algorithmOptions: {
                maxZoom: maxZoom
            },
            renderer: {
                render(cluster, stats, map) {
                    return new google.maps.Marker({
                        label: {
                            text: cluster['count'].toString(),
                            color: 'white',
                            fontSize: '12px',
                        },
                        position: cluster['position'],
                        title: 'Приблизьте для просмотра данной области',
                        icon: {
                            url: `data:image/svg+xml;base64,${window.btoa(icon)}`,
                            scaledSize: new google.maps.Size(50, 50)
                        }
                    })
                }
            }
        })

        // google.maps.event.addListener(markerClusterer, 'clusteringend', (event) => {
        //     // При окончании кластеризации скрываем все заголовки у маркеров OMS кластеризации
        //     event.markers.map((marker) => {
        //         $(marker.label.labelDiv).addClass('map__marker-label--hidden')
        //     })
        //
        //     // Показывает заголовок OMS кластеризации, когда основной кластер разбит, разница в один уровень
        //     event.clusters.map((cluster) => {
        //         cluster.markers.map((marker) => {
        //             $(marker.label.labelDiv).removeClass('map__marker-label--hidden')
        //         })
        //     })
        // })

        $(document).on('updateFiltersMap', (event, response) => {
            markerClusterer.clearMarkers()

            this.getMarkers(response['map_items']).map((marker) => {
                oms.addMarker(marker)
                markerClusterer.addMarker(marker)
            })
        })
    },

    /**
     * Преобразует объекты в маркеры для карты
     *
     * @param items
     * @return {*}
     */
    getMarkers: function (items) {
        return items.map((item, i) => {
            if (!item.coords) return

            const coords = item.coords.split(',')
            const marker = new MarkerWithLabel({
                id: item.id,
                type: item.type,
                data: item,
                position: {
                    lat: parseFloat(coords[0]),
                    lng: parseFloat(coords[1])
                },
                icon: new google.maps.MarkerImage(
                    item['icon'],
                    null,
                    null,
                    null,
                    new google.maps.Size(25, 25)
                ),
                labelContent: item['label'], // convert to string, can also be HTMLElement
                labelAnchor: new google.maps.Point(-25 / 2, -25),
                labelClass: "map__marker-label", // the CSS class for the label
                labelStyle: { opacity: 1.0 }
            })

            google.maps.event.addListener(marker, 'spider_click', debounce(() => {
                $(document).trigger('map-marker-click', {
                    data: item
                })
            }, 400))

            return marker
        })
    },
};

map.init()

export default map;
